import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import * as _moment from "moment/moment";
import { Router } from "@angular/router";
import { ForgotService } from "src/app/shared/Forgot.Service";
import * as textMask from "vanilla-text-mask/dist/vanillaTextMask.js";
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-cesbroker',
  templateUrl: './identity-mgt-cesbroker.component.html',
  styleUrls: ['./identity-mgt-cesbroker.component.scss']
})
export class IdentityMgtCesbrokerComponent implements OnInit {
  public type = '';
  public selected = '';
  public lastname = '';
  public uid = '';
  public pasteData = '';
  public pasteInd = 'N';
  public userId: string;
  public pwd: string;
  public email: string;
  error: boolean;
  message: any;
  public resp: any;
  public showId = false;
  public showpwd = false;
  public forgot: any;
  public showPlaceholder: boolean;
  public isLoading = false;
  public validate = true;
  public errorField: any = {
    email: false,
    uid: false,
    lastname: false
  };
  constructor(private router: Router,private forgotService: ForgotService, private appInsightsService: AppInsightsService) {}
  public contactText: string =
    "<b>CES Administration</b><br>" +
    "<b>Phone: </b>888-221-2294<br>" +
    "<b>Email: </b>Requests@cesadministration.com<br>";    

  @ViewChild('user') public user: ElementRef;
  @ViewChild('last') public last: ElementRef;
  @ViewChild('em') public em: ElementRef;

 emailCheck() {
    const regex = /^(([^<>()\[\]\\.,;:\s@"*~]+(\.[^<>()\[\]\\.,;:\s@"*~]+)*)|(".+"))@((([a-zA-Z0-9\-]+\.)+[a-zA-Z0-9]{2,10}))$/;
    if (!regex.test(this.email)) {
      return true;
    } else {
      return false;
    }
  }

 focusOnInput() {
    let setError = false;
    if (!!this.errorField.uid) {
      setError = true;
      setTimeout(() => this.user.nativeElement.focus(), 0);
      setTimeout(() => this.user.nativeElement.select(), 0);
      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.errorField.email) {
      setError = true;
      setTimeout(() => this.last.nativeElement.focus(), 0);
      setTimeout(() => this.last.nativeElement.select(), 0);
      window.scrollTo(0,this.last.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
  }

isErrorPresent() {
    if (!this.errorField.uid && !this.errorField.email) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['uid', 'email'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validateFields(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  validateFields(model) {
    let error = false;
    this.validate = true;
    if (model === 'uid') {
      if (!this.uid) {
        this.errorField.uid = true;
        error = true;
      } else {
        this.errorField.uid = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
  if (model === 'email') {
    if (!this.email) {
      this.errorField.email = true;
      error = true;
    } else if (this.emailCheck()) {
      this.errorField.email = true;
      error = true;
    }else {
      this.errorField.email = false;
      this.ifAtleastOneFieldValidated(model);
    }
   }

    if (!!this.uid && !!this.email && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

  cancel() {
    this.router.navigate(['/ces']);
  }

  ngOnInit() {
    console.log('ces loaded');
    window.scroll(0,0);
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("Forgot UI Page - CES");
    this.forgotService.getUid().subscribe( res => {
      this.userId = res;
      if (this.userId) {
        this.showId = true;
      }
    });
    this.forgotService.getType().subscribe( res => {
      this.pwd = res;
      if (this.pwd === 'pwd') {
        this.showpwd = true;
      }
    });
  }

  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }

  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  continue() {
      const userType = 'cesbroker';
      const userId = this.uid;
      const email = this.email;
      const json = JSON.stringify({ userId, email , userType});
      if (!this.validateAllFields()) {
        setTimeout(() => {
          window.scroll(0,0);
          this.error = false;
          this.isLoading = true;
          this.validate = true;
        });
        this.forgotService.getPassword(json).subscribe( res => {
          this.forgot =  res;
          if (this.forgot) {           
            if (this.forgot.status_code && this.forgot.status_code !== '200') {
            	setTimeout(() => {
	              this.isLoading = false;
	            });
                this.message = this.forgot.message;
                this.error = true;
                this.validate = false;
                window.scroll(0,0);
                if (this.resp.message) {
                  this.message = this.resp.message;
                } else {
                  this.message =
                    "There was an error processing your request. Please try again. If the error persists, Please call your Sales Desk for assistance.";
                }
                
              } else {
                  this.error = false;
                  let url = false;
                  if (this.forgot.url) {
                    url = true;
                    console.log("url " + this.forgot.url);
                    window.location.href = this.forgot.url;
                  }
                  if (this.forgot.questions && !url) {
                    this.forgotService.setQuestions(this.forgot.questions);
                    this.forgotService.setType('pwd');
                    this.forgotService.setUserType(userType);
                    this.router.navigate(['/ces/questions']);
                  }
              }
          }
        });
      } else {
      	this.focusOnInput();
      }
  }


    back() {
    this.router.navigate(['']);
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData("text");
    }

  }
}
